import React from 'react';
import { InstagramIcon } from 'lucide-react';
const posts = [{
  image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&q=80',
  caption: 'Jollof perfection 🍚🔥'
}, {
  image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=80',
  caption: 'Suya nights hit different 🥩'
}, {
  image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=600&q=80',
  caption: 'Cocktail hour ✨🍸'
}, {
  image: 'https://images.unsplash.com/photo-1574096079513-a8225ba06814?w=600&q=80',
  caption: 'Friday vibes only 🎶'
}, {
  image: 'https://images.unsplash.com/photo-1536935338788-846bb9981813?w=600&q=80',
  caption: 'Hibiscus Margarita 🌺'
}, {
  image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=600&q=80',
  caption: 'Plantains done right 🍌'
}, {
  image: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=600&q=80',
  caption: 'The lounge after dark 🌙'
}, {
  image: 'https://images.unsplash.com/photo-1515443961218-a51367888e4b?w=600&q=80',
  caption: 'Grilled to perfection 🐟'
}];
export function SocialTicker() {
  const tickerPosts = [...posts, ...posts];
  return <section id="gallery" className="py-20 bg-matte overflow-hidden fade-section" data-id="element-116">
      {/* Header with Instagram link */}
      <div className="flex flex-col items-center mb-12" data-id="element-117">
        <a href="https://www.instagram.com/tempoo__restaurant/" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 mb-4 hover:opacity-80 transition-opacity" data-id="element-118">
          <InstagramIcon className="w-5 h-5 text-gold" data-id="element-119" />
          <h2 className="font-sans text-sm tracking-mega-wide text-gold text-center uppercase" data-id="element-120">
            @TEMPOO__RESTAURANT
          </h2>
        </a>
        <p className="font-sans text-base text-white/40 tracking-wide" data-id="element-121">
          Follow the flavor
        </p>
      </div>

      {/* Scrolling ticker */}
      <div className="relative w-full flex overflow-hidden" data-id="element-122">
        <div className="flex animate-scroll-left" style={{
        width: `${tickerPosts.length * 320}px`
      }} data-id="element-123">
          {tickerPosts.map((post, index) => <a key={index} href="https://www.instagram.com/tempoo__restaurant/" target="_blank" rel="noopener noreferrer" className="w-72 h-72 md:w-80 md:h-80 flex-shrink-0 mx-2 overflow-hidden group cursor-pointer relative" data-id="element-124">
              <img src={post.image} alt={post.caption} className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105" data-id="element-125" />
              {/* Hover overlay with caption */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-all duration-300 flex items-end justify-center pb-6 opacity-0 group-hover:opacity-100" data-id="element-126">
                <span className="font-sans text-sm text-white px-4 text-center" data-id="element-127">
                  {post.caption}
                </span>
              </div>
            </a>)}
        </div>
      </div>

      {/* Follow CTA */}
      <div className="text-center mt-12" data-id="element-128">
        <a href="https://www.instagram.com/tempoo__restaurant/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border border-gold text-gold px-8 py-3 font-sans uppercase tracking-widest text-sm font-medium hover:bg-gold/10 transition-all duration-300" data-id="element-129">
          <InstagramIcon className="w-4 h-4" data-id="element-130" />
          Follow Us
        </a>
      </div>
    </section>;
}